export const checked = {
  getMessage: field => `Must be checked.`,
  validate: value => {
    return value === true;
  }
};
